export default __webpack_public_path__ + "static/media/no-camera.da5b02cc.png";